import React from 'react';
import classNames from 'classnames';
import spinnerIcons from './icons';

interface Props {
  containerClassName?: string;
  iconClassName?: string;
  position?: 'fixed' | 'absolute';
}

const { src, srcSet } = spinnerIcons;

const LoadingSpinner = ({ containerClassName, iconClassName }: Props) => (
  <div className={classNames('flex items-center justify-center w-full', containerClassName)}>
    <img className={classNames('w-5 h-5 animate-spin', iconClassName)} src={src} srcSet={srcSet} alt='loading' />
  </div>
);

export const FixedLoadingSpinner = ({ containerClassName, position = 'fixed', iconClassName }: Props) => {
  return (
    <LoadingSpinner
      iconClassName={iconClassName}
      containerClassName={classNames(
        position,
        'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
        containerClassName
      )}
    />
  );
};

export const InlineLoadingSpinner = ({ containerClassName, iconClassName }: Props) => {
  return (
    <LoadingSpinner
      iconClassName={iconClassName}
      containerClassName={classNames(
        'self-start flex space-x-1 items-center',
        containerClassName
      )}
    />
  );
};

export default LoadingSpinner;
